export const PricingItems = [
  {
    title: 'Model Photography',
    photos: 'Package of 50',
    resolution: '50 mp',
    price: '$50',
    imgSrc:
      'https://images.unsplash.com/photo-1617058998642-5ce6c139754b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
  },
  {
    title: 'Events Photography',
    photos: 'Package of 60',
    resolution: '70 mp',
    price: '$70',
    imgSrc:
      'https://images.unsplash.com/photo-1573055592760-a1427683e07e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1886&q=80',
  },
  {
    title: 'Corporate Photography',
    photos: 'Package of 40',
    resolution: '50 mp',
    price: '$40',
    imgSrc:
      'https://images.unsplash.com/photo-1616167916709-bbe51baf5f31?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
  },
  {
    title: 'Movies Photography',
    photos: 'Package of 80',
    resolution: '60 mp',
    price: '$90',
    imgSrc:
      'https://images.unsplash.com/photo-1512113569142-8a60fccc7caa?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
  },
];
